import { create } from 'zustand'
import type { GameInfo } from '@/models/game-info'

/**
 * Port of the Vuex `search` module — the toolbar's query text and its
 * autocomplete results. The results themselves are fetched through TanStack
 * Query (see useGameInfoAutocomplete); only the UI state lives here.
 */
interface SearchState {
  query: string
  autocomplete: GameInfo[] | null
  setQuery: (query: string) => void
  setAutocomplete: (results: GameInfo[] | null) => void
  clear: () => void
}

export const useSearchStore = create<SearchState>((set) => ({
  query: '',
  autocomplete: null,
  setQuery: (query) => set({ query }),
  setAutocomplete: (autocomplete) => set({ autocomplete }),
  clear: () => set({ query: '', autocomplete: null }),
}))
